module.exports = __webpack_public_path__ + "img/add-blue-icon.88dc553b.svg";